// Read-aloud. Recorded Sage narration first (kit/voice.ts); for text built on the fly (story
// problems with random numbers, her own stories) the phone's best English voice reads instead.

import { playLine, stopVoice } from './voice';

let enabled = true;
let voice: SpeechSynthesisVoice | null = null;

export function setTtsEnabled(on: boolean) { enabled = on; if (!on) cancelSpeech(); }

/** Prefer the natural-sounding network and neural voices Android and Chrome offer. */
function pickVoice() {
  if (voice || !('speechSynthesis' in window)) return;
  const vs = speechSynthesis.getVoices().filter(v => /^en[-_]/i.test(v.lang));
  const score = (v: SpeechSynthesisVoice) =>
    (/en[-_]US/i.test(v.lang) ? 4 : 0) +
    (/natural|neural|enhanced|premium|online/i.test(v.name) ? 6 : 0) +
    (/google/i.test(v.name) ? 3 : 0) +
    (!v.localService ? 2 : 0) +
    (/female|samantha|zira|aria|jenny/i.test(v.name) ? 1 : 0);
  voice = vs.sort((a, b) => score(b) - score(a))[0] || null;
}

export function speak(text: string, opts: { rate?: number; interrupt?: boolean } = {}) {
  if (!enabled || !text) return;
  if (playLine(text)) { if ('speechSynthesis' in window) speechSynthesis.cancel(); return; }
  if (!('speechSynthesis' in window)) return;
  pickVoice();
  if (opts.interrupt !== false) { speechSynthesis.cancel(); stopVoice(); }
  const u = new SpeechSynthesisUtterance(text);
  u.rate = opts.rate ?? 0.92;
  u.pitch = 1.0;
  if (voice) u.voice = voice;
  speechSynthesis.speak(u);
}

export function cancelSpeech() {
  stopVoice();
  if ('speechSynthesis' in window) speechSynthesis.cancel();
}

if ('speechSynthesis' in window) {
  speechSynthesis.addEventListener?.('voiceschanged', () => { voice = null; pickVoice(); });
}
